export default "__VITE_ASSET__DfGQTEVM__"